/**
 * TYPE_USAGE payload shape: detect kind from payload structure (fallback when unifiedGraftModelType is missing).
 * Predicates check by protocol type kind (TYPE_USAGE_NODE_KIND).
 */

import { TYPE_USAGE_NODE_KIND, TypeUsageNodeKind } from '../../const/typeUsageNodeKind.const'

import { isNullableFlag } from './nullable.type-usage'

/** Detects which TYPE_USAGE_* kind the payload shape matches; null if invalid or unknown. */
export function getTypeUsagePayloadShapeKind(payload: unknown[]): TypeUsageNodeKind | null {
  if (payload.length === 1 && isNullableFlag(payload[0])) return TYPE_USAGE_NODE_KIND.TYPE_USAGE_VOID
  if (payload.length === 2 && typeof payload[1] === 'string') return TYPE_USAGE_NODE_KIND.TYPE_USAGE_GENERIC_ALIAS
  if (payload.length >= 3 && typeof payload[1] === 'number') return TYPE_USAGE_NODE_KIND.TYPE_USAGE_ARRAY
  if (payload.length >= 4 && typeof payload[1] === 'string' && typeof payload[2] === 'string')
    return TYPE_USAGE_NODE_KIND.TYPE_USAGE_PRIMITIVE
  if (payload.length >= 3 && typeof payload[1] === 'string') return TYPE_USAGE_NODE_KIND.TYPE_USAGE_GENERIC
  return null
}

/** True if payload shape indicates TYPE_USAGE_VOID (e.g. single nullable flag). */
export function isVoidTypeUsagePayload(payload: unknown[]): boolean {
  return getTypeUsagePayloadShapeKind(payload) === TYPE_USAGE_NODE_KIND.TYPE_USAGE_VOID
}

/** True if payload shape indicates TYPE_USAGE_GENERIC_ALIAS (e.g. generic param "T"). */
export function isGenericAliasTypeUsagePayload(payload: unknown[]): boolean {
  return getTypeUsagePayloadShapeKind(payload) === TYPE_USAGE_NODE_KIND.TYPE_USAGE_GENERIC_ALIAS
}

/** True if payload shape indicates TYPE_USAGE_ARRAY (dimension + element type). */
export function isArrayTypeUsagePayload(payload: unknown[]): boolean {
  return getTypeUsagePayloadShapeKind(payload) === TYPE_USAGE_NODE_KIND.TYPE_USAGE_ARRAY
}

/** True if payload shape indicates TYPE_USAGE_PRIMITIVE (namespace, typename, primitive type code, etc.). */
export function isPrimitiveTypeUsagePayload(payload: unknown[]): boolean {
  return getTypeUsagePayloadShapeKind(payload) === TYPE_USAGE_NODE_KIND.TYPE_USAGE_PRIMITIVE
}

/** True if payload shape indicates TYPE_USAGE_GENERIC (generic name + type args). */
export function isGenericTypeUsagePayload(payload: unknown[]): boolean {
  return getTypeUsagePayloadShapeKind(payload) === TYPE_USAGE_NODE_KIND.TYPE_USAGE_GENERIC
}
